import { Component, Input } from '@angular/core';

import { Background, backgroundEnum } from '../../../shared/enums';

@Component({
    selector: 'cmn-jumbotron',
    templateUrl: './jumbotron.component.html',
    styleUrls: [ './jumbotron.component.scss' ],
})

export class JumbotronComponent {
    @Input() public readonly isFlex: boolean;
    @Input('class') public readonly clazz: string;
    @Input() public readonly hasContainer: boolean;
    @Input() public readonly background: Background = backgroundEnum.light;
}
